<template>
  <div class="pw-layout" :class="`pw-align-${align}`">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Layout',
  props: {
    align: {
      type: String,
      default: 'left',
    },
  },
};
</script>

<style lang="scss" scoped>
.pw-layout {
  display: flex;
  flex-wrap: wrap;
  margin-right: -8px;
  margin-left: -8px;
  &.pw-align-right {
    justify-content: flex-end;
  }
  &.pw-align-center {
    justify-content: center;
  }
}
</style>
